var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84535 4.52295C2.94982 4.27072 3.19595 4.10626 3.46896 4.10626H20.5315C20.8045 4.10626 21.0506 4.27072 21.1551 4.52295C21.2596 4.77518 21.2018 5.06551 21.0088 5.25856L12.4775 13.7898C12.2139 14.0534 11.7865 14.0534 11.5229 13.7898L2.99167 5.25856C2.79862 5.06551 2.74087 4.77518 2.84535 4.52295ZM5.09856 5.45626L12.0002 12.3579L18.9019 5.45626H5.09856Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 12.6375C12.373 12.6375 12.6752 12.9397 12.6752 13.3125V19.2188C12.6752 19.5916 12.373 19.8938 12.0002 19.8938C11.6274 19.8938 11.3252 19.5916 11.3252 19.2188V13.3125C11.3252 12.9397 11.6274 12.6375 12.0002 12.6375Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04395 19.2188C8.04395 18.846 8.34615 18.5438 8.71895 18.5438H15.2814C15.6542 18.5438 15.9564 18.846 15.9564 19.2188C15.9564 19.5916 15.6542 19.8938 15.2814 19.8938H8.71895C8.34615 19.8938 8.04395 19.5916 8.04395 19.2188Z",
    fill: "#383733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41895 7.40626C5.41895 7.03347 5.72115 6.73126 6.09395 6.73126H17.9064C18.2792 6.73126 18.5814 7.03347 18.5814 7.40626C18.5814 7.77905 18.2792 8.08126 17.9064 8.08126H6.09395C5.72115 8.08126 5.41895 7.77905 5.41895 7.40626Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.e7b47fcf193b2ad7b1a171ac2fc61d56.svg";
export { ForwardRef as ReactComponent };